import { render, staticRenderFns } from "./SchoolCard.vue?vue&type=template&id=c22a5746&"
import script from "./SchoolCard.vue?vue&type=script&lang=ts&"
export * from "./SchoolCard.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolCard.vue?vue&type=style&index=0&id=c22a5746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports